import sessionService from '@/services/helper/session.service';

export default [
  {
    description: 'Chat',
    path: '/ferramentas/chat',
    name: 'chat',
    component: () => import('@/views/ferramentas/chat/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    beforeEnter: () => {
      if (sessionService.IsAluno()) return '/homealuno';
      if (sessionService.IsResponsavel()) return '/ferramentas/chat-responsavel';
      return true;
    },
    goesToMenu: true,
  },
  {
    description: 'Chat seguro do responsável',
    path: '/ferramentas/chat-responsavel',
    name: 'chat-seguro-responsavel',
    component: () => import('@/views/ferramentas/chatseguro/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [],
    },
    beforeEnter: () => {
      if (sessionService.IsResponsavel()) return true;
      return sessionService.IsAluno() ? '/homealuno' : '/home';
    },
    goesToMenu: false,
  },
]

